/**
 * `LakikaveriPopulatedBody` — thin wrapper around `SanitizedHtml` that
 * renders the lifted `body_html` for the `lakikaveri-info` article
 * (intro prose + "Missä asioissa voimme auttaa?" bullet list +
 * closing paragraph).
 *
 * Why a named component, not an inline `<SanitizedHtml>` call site?
 *
 *   - Keeps the route file's populated branch reading top-down as
 *     "header → body → steps → outbound link" rather than
 *     "header → SanitizedHtml-with-classes-and-html-prop → steps →
 *     outbound link" — the prose line is one concern, the steps are
 *     another, and a named component makes that intent explicit.
 *   - Locks the `bodyClasses` token + the `as="div"` choice at one
 *     site; future copy / classname tweaks land here, not on the
 *     route.
 *   - Lets the route file stay well under the FR-045 file-size
 *     ceiling without hiding the body-rendering decision behind a
 *     comment alone.
 *
 * Spec references: same as `LakikaveriInfoRoute.tsx` (TA20.2).
 */

import type { JSX } from 'react';

import { SanitizedHtml } from '../components/SanitizedHtml.js';
import { bodyClasses } from './articleDetailSurface.js';

export interface LakikaveriPopulatedBodyProps {
  readonly bodyHtml: string;
}

export function LakikaveriPopulatedBody({ bodyHtml }: LakikaveriPopulatedBodyProps): JSX.Element {
  return <SanitizedHtml as="div" className={bodyClasses} html={bodyHtml} />;
}
